import { Component, OnInit, Input, Optional } from '@angular/core';
import {countries} from 'countries-list';
import { MobileService } from '../_services/mobile.service';
import { environment } from 'environments/environment';
import { User } from 'app/interfaces/user';
import { LanguageService } from 'app/services/language.service';
import { CurrentUser } from 'app/services/currentUser.service';
import { UserAccount } from 'app/services/userAccount.service';
import { Router } from '@angular/router';
import { AccountService } from '../account.service';
import { FirebaseService } from 'app/services/firebase.service';
import { AppConfigService } from 'app/services/app-config.service';
import { ToasterService } from 'angular2-toaster';
import { FacebookPixelService } from 'app/services/facebook-pixel.service';

@Component({
  selector: 'app-mobile-sign-up',
  templateUrl: './mobile-sign-up.component.html',
  styleUrls: ['./mobile-sign-up.component.scss', '../account.scss']
})
export class MobileSignUpComponent implements OnInit {
  @Input() updateGuest;
  @Input() noPhotos;

  user = new User();

  // user: User = {
  //   username: '',
  //   password: '',
  //   first_name: '',
  //   last_name: '',
  //   profile: {
  //     country: environment.countries[0],
  //     language: this.languageService.getBrowserLang(), // supports en & fr
  //     mobile_number: '',
  //   },
  // };

  countryList = [];

  chosenCountry = {
    capital: '',
    continent: '',
    currency: '',
    emoji: '',
    emojiU: '',
    languages: [],
    name: '',
    native: '',
    phone: ''
  };

  step = 1;

  loadingUserCountry = true;


  isSelectOpen = false;
  phoneNumber = '';
  phoneCode = '';
  verificationCode = null;
  completePhoneNumber;

  errors = {
    phone: '',
    code: '',
    password: '',
    first_name: '',
    last_name: '',
    terms: false,
  };


  isLoading;
  privacyPolicyLink = environment.privacyPolicyLink;
  termsOfUseLink = environment.termsOfUseLink;
  termsOfUseAccepted;
  privacyPolicyAccepted;



  constructor(
    public accountService: AccountService,
    public firebaseService: FirebaseService,
    private mobileService: MobileService,
    private languageService: LanguageService,
    private appConfigService: AppConfigService,
    private toasterService: ToasterService,
    private router: Router,
    private facebookPixelService: FacebookPixelService,
    @Optional() private currentUser: CurrentUser,
    @Optional() private userAccount: UserAccount,
    ) {
      this.countryList = Object.keys(countries).map(function(personNamedIndex) {
        const country = countries[personNamedIndex];
        return country;
    });
    }

  ngOnInit() {
    const data = this.appConfigService.config.geo_info;
    this.chosenCountry = this.countryList.find(country => country.name === data['country_name']);
    this.phoneCode = '+' + this.chosenCountry.phone;
    this.loadingUserCountry = false;
  }



  toggleSelect() {
    this.isSelectOpen = !this.isSelectOpen;
  }

  handleSelect(country) {
    this.chosenCountry = country;
    this.phoneCode = `+${country.phone}`;
    this.phoneNumber = '';
    this.isSelectOpen = false;
  }

  mobileNumberSubmit() {
    this.completePhoneNumber = this.phoneCode + this.phoneNumber;
    this.mobileService.sendCode(this.completePhoneNumber).subscribe(
      () => {
        this.step = 2;
      },
      (err) => {
        console.log(err);
        if (err.status === 409 ) {
          this.toasterService.pop('error', undefined, 'Mobile number already in use');
          this.router.navigate(['/account/login/mobile'], { queryParams: { cred: this.phoneNumber}});
        } else {
          this.errors.phone = 'Invalid number';
        }
      }
    );
  }

  verificationCodeSubmit() {
    this.mobileService.verifyMobileNumber(this.completePhoneNumber, this.verificationCode).subscribe(
      () => {
        this.step = 3;
      },
      () => {
        this.errors.code = 'Invalid code';
      }
    );
  }

  handleSubmit() {
    console.log('SUBMIT');
  }

  get charactersLength() {
    return 12 - this.phoneCode.length;
  }


  isUserValid() {
    return (
      this.user.password &&
      this.user.first_name &&
      this.user.last_name &&
      !this.isLoading
    );
  }

  onSubmit() {
    if (!this.termsOfUseAccepted || !this.privacyPolicyAccepted) {
      this.errors.terms = true;
      return null;
    }
    this.errors.terms = false;
    this.isLoading = true;
    if (this.updateGuest) {
       this.currentUser.updateGuest(this.user).subscribe(x => {
        this.currentUser.updateCurrentUser(this.user);
        this.userAccount.set(this.user);
        if (this.noPhotos) {
          this.router.navigate(['/stories']);        }
      });

    } else {
      this.user.code = this.verificationCode;
      this.user.username = this.completePhoneNumber;

      this.accountService.signUp(this.user).subscribe(
            data => {
              this.firebaseService.setUserId(data.user_id);
              this.firebaseService.logEvent('sign_up', {
                method: 'mobile_number',
              });
              this.facebookPixelService.trackEvent('CompleteRegistration' , {
                method: 'mobile_number',
              });
              this.firebaseService.userProperties({ first_open_time: new Date() });
              this.isLoading = false;
            },
            errors => {
              this.isLoading = false;
              this.errors = errors;
              this.firebaseService.logEvent('sign_up_error', {
                reason: errors.detail,
              });
            }
          );
    }
  }

}
